// returns an array from 'start' digit to 'stop' digit with 'step' difference
// range(1, 10, 2) // [1, 3, 5, 9]
export const range = (start: number, stop: number, step: number) =>
  Array.from({ length: (stop - start) / step + 1 }, (_, i) => start + i * step);
